var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary__assignments"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(counsellor){return _c('summary-assignments-item',{key:counsellor.filterValue,attrs:{"counsellor":counsellor}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }